/* default talent module names */
export const defaultModulesNames = [
  {
    value: 'Inicio',
    label: 'common.competences.menu_home_title',
  },
  {
    value: 'Mi equipo',
    label: 'common.menu_my_team',
  },
  {
    value: 'Seguimiento',
    label: 'common.menu_dashboard_leader',
  },
  {
    value: 'Gestión',
    label: 'common.menu_dashboard_leader_management',
  },
  {
    value: 'Desempeño',
    label: 'common.menu_dashboard_leader_performance',
  },
  {
    value: 'Aprendizaje',
    label: 'common.menu_dashboard_leader_learning',
  },
  {
    value: 'Resultados',
    label: 'common.menu_my_team_results',
  },
  {
    value: 'Estadísticas',
    label: 'common.module_stadistics_analytics_title',
  },
  {
    value: 'Talent',
    label: 'common.talent',
  },
  {
    value: 'Learning',
    label: 'common.module_learning_title',
  },
  {
    value: 'Reportes',
    label: 'common.module_reports_analytics_title',
  },
  {
    value: 'Talent',
    label: 'common.talent',
  },
  {
    value: 'Learning',
    label: 'common.module_learning_title',
  },
  {
    value: 'N-Box',
    label: 'common.nbox_module_title',
  },
  {
    value: 'N-Box',
    label: 'common.nbox_module_title',
  },
  {
    value: 'Hana',
    label: 'common.menu_hana_title',
  },
  {
    value: 'Gestión',
    label: 'common.menu_management_title',
  },
  {
    value: 'Compañia',
    label: 'common.company',
  },
  {
    value: 'Usuarios',
    label: 'common.admin_menu_users',
  },
  {
    value: 'Áreas y sedes',
    label: 'common.menu_areas_and_headquarters',
  },
  {
    value: 'Grupos',
    label: 'common.menu_groups',
  },
  {
    value: 'Departamentos',
    label: 'common.module_division_admin_company_title',
  },
  {
    value: 'Cargos y categorías',
    label: 'common.menu_positions_and_categories',
  },
  {
    value: 'Cargos',
    label: 'common.module_jobs_admin_company_title',
  },
  {
    value: 'Atributos personalizados',
    label: 'common.admin_menu_personalized_attributes',
  },

  {
    value: 'Organigrama',
    label: 'common.menu_organization_chart',
  },
  {
    value: 'Configuración',
    label: 'common.module_configuration_company_title',
  },
  {
    value: 'Documentos corporativos',
    label: 'common.menu_documents_title',
  },
  {
    value: 'Tiempo libre',
    label: 'common.menu_free_time_title',
  },
  {
    value: 'Políticas',
    label: 'common.menu_free_time_policies',
  },
  {
    value: 'Solicitudes',
    label: 'common.menu_free_time_request',
  },
  {
    value: 'Feriados',
    label: 'common.menu_free_time_holidays',
  },
  {
    value: 'Calendario',
    label: 'common.menu_free_time_calendar',
  },
  {
    value: 'Configuración',
    label: 'common.menu_free_time_configuration',
  },
  {
    value: 'Solicitar tiempo libre',
    label: 'common.menu_free_time_enduser_request',
  },
  {
    value: 'Solicitudes rechazadas',
    label: 'common.menu_free_time_rejected_request',
  },
  {
    value: 'Automatizaciones',
    label: 'common.admin_menu_automations',
  },
  {
    value: 'Flujos de trabajo',
    label: 'common.admin_menu_automations_workflows',
  },
  {
    value: 'Asignación de aprendizaje',
    label: 'common.admin_menu_automations_knowledge',
  },
  {
    value: 'Reconocimiento',
    label: 'common.module_recognition_title',
  },
  {
    value: 'Resultados',
    label: 'common.menu_recognition_results',
  },
  {
    value: 'Solicitud de medallas',
    label: 'common.admin_menu_medals_request',
  },
  {
    value: 'Recompensas',
    label: 'common.menu_rewards',
  },
  {
    value: 'configuración',
    label: 'common.configuration',
  },
  {
    value: 'medallas',
    label: 'common.menu_medals',
  },
  {
    value: 'mensajes',
    label: 'common.admin_menu_messages',
  },
  {
    value: 'reglas y permisos',
    label: 'common.admin_menu_rules_and_permissions',
  },
  {
    value: 'Desempeño',
    label: 'common.module_performance_title',
  },
  {
    value: 'Resultados',
    label: 'common.module_results_performance_title',
  },

  {
    value: 'Competencias',
    label: 'common.module_competences_title',
  },
  {
    value: 'Metas',
    label: 'common.module_goals_title',
  },
  {
    value: "OKR's",
    label: 'common.module_okrs_title',
  },
  {
    value: 'Objetivos',
    label: 'common.menu_goals',
  },
  {
    value: 'Alineación',
    label: 'common.menu_alignment',
  },
  {
    value: 'Feedback',
    label: 'common.module_feedback_title',
  },
  {
    value: 'Plan individual de desarrollo',
    label: 'common.module_pid_title',
  },
  {
    value: 'Plan de sucesión',
    label: 'common.module_succession_plan_title',
  },
  {
    value: 'Clima',
    label: 'common.module_engagement_title',
  },
  {
    value: 'Resultados',
    label: 'common.menu_climate_results',
  },
  {
    value: 'Evaluaciones de clima',
    label: 'common.module_climate_title',
  },
  {
    value: 'Encuestas cortas',
    label: 'common.admin_menu_short_surveys',
  },
  {
    value: 'Otras evaluaciones',
    label: 'common.admin_menu_other_evaluations',
  },
  {
    value: 'Aprendizaje',
    label: 'common.module_learning_title',
  },
  {
    value: 'Inicio',
    label: 'common.menu_dashboard',
  },
  {
    value: 'Skill XP Evolution',
    label: 'common.home_learning_card_title',
  },
  {
    value: '1200 Cursos',
    label: 'common.module_more_courses_fakedoors_title',
  },
  {
    value: 'Exp. de aprendizaje',
    label: 'common.admin_menu_elevate_lxp',
  },
  {
    value: 'Trabajo remoto',
    label: 'common.module_homeoffice_title',
  },
  {
    value: 'Reclutamiento',
    label: 'common.module_recruiting_title',
  },
  {
    value: 'Administrar',
    label: 'common.menu_footer_admin',
  },
  {
    value: 'Cuenta',
    label: 'common.avatar_account',
  },
  {
    value: 'Logs',
    label: 'common.module_logs_admin_company_title',
  },
  {
    value: 'Apariencia',
    label: 'common.admin_menu_appearance',
  },

  {
    value: 'Comunicaciones',
    label: 'common.admin_menu_communication',
  },
  {
    value: 'Roles y permisos',
    label: 'common.module_roles_permissions_company_title',
  },
  {
    value: 'Empresa',
    label: 'common.menu_company_title',
  },
  {
    value: 'Compañia - Directorio',
    label: 'common.menu_directory',
  },
  {
    value: 'Analítica',
    label: 'common.menu_analytics_title',
  },
  {
    value: 'Mis resultados',
    label: 'common.menu_my_results',
  },
  {
    value: 'Clima - Encuestas',
    label: 'common.module_survey_title',
  },
  {
    value: 'Empleados',
    label: 'common.module_employees_admin_company_title',
  },
  {
    value: 'Campos extra',
    label: 'common.module_extra_fields_company_title',
  },
];
